import { dynamicWrapper, createRoute } from '@/utils/core';

const routesConfig = app => ({
  path: '/clientOnlineStatistics',
  title: window.language['menu.log.clientOnline'],
  component: dynamicWrapper(app, [import('./model'), import('../HomePage/model')], () => import('./components')),
});

export default app => createRoute(app, routesConfig);



// WEBPACK FOOTER //
// ./src/routes/ClientOnlineStatistics/index.js